module.exports = __webpack_public_path__ + "static/media/confeti.05d69479.png";